export default "__VITE_ASSET__CKLvOvMm__"